<template>
    <section class="inner_banner">
        <div class="container">
            <h2 class="title">Contact</h2>
            <div class="aditional-text p-5">
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia iste eos, doloremque quas aspernatur eaque consectetur laudantium, dignissimos voluptatibus nihil ipsam qui eum excepturi labore maiores odit asperiores amet quis.</p>
            </div>
            <!-- <div class="contact-form">
                <form>
                    <label>
                    <h5>Your Name</h5>
                    <input type="text" name="">
                    </label>

                    <label>
                    <h5>Your Email</h5>
                    <input type="text" name="">
                    </label>

                    <label>
                    <h5>Your Message</h5>
                    <textarea></textarea>
                    </label>

                </form>
            </div> -->
        </div>
    </section>
</template>

<script>
export default {
    name: "Contact"
}
</script>

<style scoped>

</style>
